import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin, Mail, Award, TrendingUp, Users, GraduationCap } from "lucide-react";

export default function Instructor() {
  return (
    <div>
      <section className="border-b border-white/10">
        <div className="container-x py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <img
                src="/images/zulfikar-benli.webp"
                alt="Zülfikar Benli"
                className="w-full aspect-[4/5] object-cover"
              />
              <div className="absolute inset-0 border border-gold-30 -m-4 -z-10" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <span className="section-eyebrow">Kurucu · Baş Eğitmen</span>
            <h1 className="font-display text-5xl md:text-6xl mt-4 leading-tight">
              Zülfikar <span className="italic gold-gradient-text">Benli</span>
            </h1>
            <p className="mt-6 text-lg text-white/75 leading-relaxed max-w-2xl">
              25 yılı aşkın aktif muhasebe sektörü ve mali müşavirlik ofisi yönetimi deneyimi,
              15 yılı aşkın eğitmenlik geçmişi. 500'den fazla ön muhasebe ve genel muhasebe
              profesyoneli yetiştirdi. Sahada gerçekten işe yarayan bilgiyi, akademik teoriyle
              harmanlayarak sunuyor.
            </p>

            <div className="mt-8 flex items-center gap-4">
              <a href="https://instagram.com/zbcampus" target="_blank" rel="noreferrer" className="btn-outline text-sm" data-testid="instr-instagram">
                <Instagram className="w-4 h-4" /> Instagram
              </a>
              <a href="https://youtube.com/@zbcampus" target="_blank" rel="noreferrer" className="btn-outline text-sm" data-testid="instr-youtube">
                <Youtube className="w-4 h-4" /> YouTube
              </a>
              <a href="https://linkedin.com/in/zulfikarbenli" target="_blank" rel="noreferrer" className="btn-outline text-sm" data-testid="instr-linkedin">
                <Linkedin className="w-4 h-4" /> LinkedIn
              </a>
              <a href="mailto:info@zbcampus.com" className="text-white/60 hover:text-gold" data-testid="instr-mail">
                <Mail className="w-5 h-5" />
              </a>
            </div>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
              <Stat icon={<TrendingUp className="w-5 h-5" />} value="25+" label="Yıl Sektör Deneyimi" />
              <Stat icon={<GraduationCap className="w-5 h-5" />} value="15+" label="Yıl Eğitmenlik" />
              <Stat icon={<Users className="w-5 h-5" />} value="500+" label="Öğrenci" />
              <Stat icon={<Award className="w-5 h-5" />} value="5" label="Program" />
            </div>
          </div>
        </div>
      </section>

      <section className="container-x py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div>
            <span className="section-eyebrow">Uzmanlık</span>
            <h2 className="font-display text-3xl mt-4">Alanlar</h2>
          </div>
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-5">
            {[
              { t: "Ön Muhasebe & e-Belge", d: "Fatura, cari, stok ve e-Belge süreçlerinde uzmanlaşma." },
              { t: "Genel Muhasebe", d: "TDHP, yevmiye kayıtları, mali tablo hazırlığı." },
              { t: "Vergi Beyanları", d: "KDV, muhtasar, kurumlar vergisi beyannameleri." },
              { t: "Dönem Sonu İşlemleri", d: "Amortisman, karşılık, ertelenmiş vergi." },
            ].map((it) => (
              <div key={it.t} className="bg-surface border border-white/10 p-6">
                <div className="font-display text-xl">{it.t}</div>
                <p className="text-sm text-white/60 mt-2">{it.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-x pb-24">
        <div className="border border-gold-30 bg-surface p-10 md:p-16 text-center">
          <span className="section-eyebrow">Eğitim Almaya Hazır Mısınız?</span>
          <h2 className="font-display text-4xl md:text-5xl mt-4">
            <span className="italic gold-gradient-text">Zülfikar</span> ile öğrenmeye başlayın.
          </h2>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/egitimler" className="btn-primary">Eğitimleri İncele</Link>
            <Link to="/iletisim" className="btn-outline">İletişime Geçin</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function Stat({ icon, value, label }) {
  return (
    <div className="border-l border-gold-30 pl-4">
      <div className="text-gold mb-1">{icon}</div>
      <div className="font-display text-3xl text-white">{value}</div>
      <div className="text-xs uppercase tracking-widest text-white/50 mt-1">{label}</div>
    </div>
  );
}
